// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_hj","advertCardHeader__actions":"c-a_hk","advertCardHeader__bottomLabel":"c-a_hl"};